import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../service/axiosInstance";
import { API_ENDPOINT } from "../../../config/config";

const getDefaultYear = () => new Date().getFullYear();

const parseCommonSettings = (payload) =>
  payload?.results?.[0]
  ?? payload?.data?.results?.[0]
  ?? payload?.results
  ?? payload?.data
  ?? payload
  ?? null;

const initialState = {
  loading: false,
  loaded: false,
  year: getDefaultYear(),
  error: null,
};

export const fetchCommonSettings = createAsyncThunk(
  "commonSettings/fetchCommonSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINT}user/settings/common/`);
      const settings = parseCommonSettings(response?.data);
      const parsedYear = Number(settings?.year);
      return {
        year: Number.isFinite(parsedYear) && parsedYear > 0 ? parsedYear : getDefaultYear(),
      };
    } catch (error) {
      if (error?.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error?.message || "Failed to fetch common settings");
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState();
      const commonSettings = state?.commonSettings;
      if (!commonSettings) return true;
      return !commonSettings.loading && !commonSettings.loaded;
    },
  }
);

const commonSettingsSlice = createSlice({
  name: "commonSettings",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCommonSettings.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [fetchCommonSettings.fulfilled]: (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.year = action.payload?.year || state.year;
      state.error = null;
    },
    [fetchCommonSettings.rejected]: (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.error = action.payload || action.error?.message || null;
    },
  },
});

export const selectCommonSettings = (state) => state.commonSettings;
export const selectCommonYear = (state) => state.commonSettings?.year || getDefaultYear();

export default commonSettingsSlice.reducer;
